import React from 'react';

const EditProfile = () => {
    return (
        <div>
            <p>Edit Profile</p>
        </div>
    );
};

export default EditProfile;